<template>
  <div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  }
}
</script>